<!--<ul  class="breadcrumbClass">-->
<!--<li><a href="#">Home</a></li>-->
<!--<li><a href="#">Pictures</a></li>-->
<!--<li><a href="#">Summer 15</a></li>-->
<!--<li>Italy</li>-->
<!--</ul>-->
<div class="container-fluid">
    <ul class="breadcrumb" style="list-style: none;">

        <li *ngFor="let bread_crumb of breadcrumbs">
            <button mat-button [routerLink]="bread_crumb.route_link">{{bread_crumb.route_title}}</button>

        </li>

    </ul>
</div>